import css from './index.module.scss';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, ImgCellsWithText, TextWithImage, SwiperBanner } from '@/componentsH5/ProductDetailComponents';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';
import NextImage from '@/components/NextImage';

const product: any = {
    us: ['product_ps_river_river_pro_720', 'product_ps_delta_delta_1300', 'product_ps_delta_delta_max'],
    cis: ['product_ps_delta_delta_max'],
    eu: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    uk: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    de: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    fr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    it: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    es: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    tw: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    kr: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    cn: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
    br: ['product_ps_river_river_256', 'product_ps_delta_delta_2', 'product_ps_delta_delta_2_max'],
    mx: ['product_ps_delta_delta_3_s', 'product_ps_river_river_768', 'product_ps_delta_delta_2'],
};

export default function SolarPanel160W() {
    const { gloproductlist, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('product');
    const languageT = (value: string) => t(`solarpanels.${value}`);
    const webpUrl = '/media/solarpanel_160w/h5/';

    const bannerData3 = [
        {
            img: ['design.webp', 'design.jpg'],
            alt: languageT('banD3_item_alt'),
            desc: languageT('banD3_item1_desc'),
        },
        {
            img: ['2.webp', '2.png'],
            alt: languageT('banD3_item_alt'),
            desc: languageT('banD3_item2_desc'),
        },
        {
            img: ['3.webp', '3.png'],
            alt: languageT('banD3_item_alt'),
            desc: languageT('banD3_item3_desc'),
        },
    ];

    const imgCellData = {
        guide: languageT(locale === 'jp' ? 'imgCellData_guide_jp' : 'imgCellData_guide'),
        title: languageT(locale === 'jp' ? 'imgCellData_tit_jp' : 'imgCellData_tit'),
        desc1: languageT('imgCellData_desc1'),
        desc2: languageT('imgCellData_desc2'),
        supliment: languageT('imgCellData_sup'),
        items: [
            {
                url: '/img/mobile/solarpanel/panel_01.png',
                guide: languageT('imgcell_item1_guid'),
                titleLeft: languageT('imgcell_item1_titl'),
                titleRight: languageT('imgcell_item1_titr'),
                desc: languageT('imgcell_item1_desc'),
            },
            {
                url: '/img/mobile/solarpanel/panel_02.png',
                guide: languageT('imgcell_item2_guid'),
                titleLeft: languageT('imgcell_item2_titl'),
                titleRight: languageT('imgcell_item2_titr'),
                desc: languageT('imgcell_item2_desc'),
            },
            {
                url: '/img/mobile/solarpanel/panel_03.png',
                guide: languageT('imgcell_item3_guid'),
                titleLeft: languageT('imgcell_item3_titl'),
                titleRight: languageT('imgcell_item3_titr'),
                desc: languageT('imgcell_item3_desc'),
            },
            {
                url: '/img/mobile/solarpanel/panel_04.png',
                guide: languageT('imgcell_item4_guid'),
                titleLeft: languageT('imgcell_item4_titl'),
                titleRight: languageT('imgcell_item4_titr'),
                desc: languageT('imgcell_item4_desc'),
            },
        ],
    };

    const synopsisFontSize: any = {
        us: 0.24,
        jp: 0.21,
        de: 0.23,
    };

    return (
        <div className={`${css.animationWrapper} solarPanelModule`}>
            <div className="page-solarpanel-banner">
                <BannerModule
                    data={[
                        {
                            bgImgs: ['banner_160w.webp', 'banner_160w.jpg'],
                            title: languageT('160w_title'),
                            des: languageT('solar_panels'),
                            logo_url: '/img/logo.png',
                        },
                    ]}
                    config={{ theme: 'black', isShowLogo: false, webpUrl }}
                />
            </div>
            <div className="banner-content">
                <div className="section section1">
                    <h3 className="tit">{languageT('ytdd_sec1-top_tit')}</h3>
                    <div className="bg-img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_160w/h5/section1.webp')}
                            src={require('@publicLocal/product/solarpanel_160w/h5/section1.png')}
                            className="fullImgs"
                            alt={languageT('solar_panels')}
                        />
                    </div>
                </div>
                <div className="section section2">
                    <div className="sec2-top">
                        <div className="section sec2-top-l">
                            <h3 className="tit">{languageT('ytdd_sec2-top-r_tit')}</h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_160w/h5/sec2-top-l.webp')}
                                    src={require('@publicLocal/product/solarpanel_160w/h5/sec2-top-l.jpg')}
                                    className="fullImgs"
                                    alt={languageT('solar_panels')}
                                />
                            </div>
                        </div>
                        <div className="section sec2-top-r">
                            <h3 className="tit">{languageT('ytdd_sec2-top-l_tit')}</h3>
                            <div className="bg-img">
                                <NextImage
                                    webpSrc={require('@publicLocal/product/solarpanel_160w/h5/sec2-top-r.webp')}
                                    src={require('@publicLocal/product/solarpanel_160w/h5/sec2-top-r.png')}
                                    className="fullImgs"
                                    alt={languageT('solar_panels')}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="section sec2-btm">
                        <h3 className="tit">{languageT('ytdd_sec1-btm_tit')}</h3>
                        <div className="bg-img">
                            <NextImage
                                webpSrc={require('@publicLocal/product/solarpanel_160w/h5/sec2-btm.webp')}
                                src={require('@publicLocal/product/solarpanel_160w/h5/sec2-btm.png')}
                                className="fullImgs"
                                alt={languageT('solar_panels')}
                            />
                        </div>
                    </div>
                </div>
                <div className="section section3">
                    <h3 className="tit">{languageT('ytdd_sec2-btm_tit')}</h3>
                    <div className="bg-img">
                        <NextImage
                            webpSrc={require('@publicLocal/product/solarpanel_160w/h5/section3.webp')}
                            src={require('@publicLocal/product/solarpanel_160w/h5/section3.png')}
                            className="fullImgs"
                            alt={languageT('solar_panels')}
                        />
                    </div>
                </div>
            </div>
            <div className="textImg">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        position: 'top',
                        synopsisFontSize: locale === 'jp' ? 0.22 : 0.24,
                        webpUrl,
                    }}
                    data={{
                        synopsis: languageT(locale === 'jp' ? 'item1_synopsis_h5' : 'item1_synopsis'),
                        desc: languageT('item1_desc'),
                        img_url: ['panels.webp', 'panels.jpg'],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        webpUrl,
                        synopsisFontSize: synopsisFontSize[locale] || synopsisFontSize.us,
                    }}
                    data={{
                        title: languageT('textData1_tit'),
                        synopsis: languageT(locale === 'jp' ? 'textData1_synopsis_h5' : 'textData1_synopsis'),
                        desc: languageT('textData1_desc'),
                        img_url: ['energy_160w.webp', 'energy_160w.jpg'],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="imgCellData-160">
                <ImgCellsWithText data={imgCellData} webpUrl={webpUrl} />
            </div>

            <LineSpace height={1.2} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, fullScreen: false, position: 'top', webpUrl }}
                    data={{
                        title: languageT('mc_connectors'),
                        synopsis: languageT('perfect_couple'),
                        desc: languageT('perfect_couple_desc'),
                        img_url: ['connectors.webp', 'connectors.jpg'],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />

            <div className="textImg design">
                <SwiperBanner
                    data={{
                        guide: { text: languageT('swiper_guide') },
                        title: { text: languageT('swiper_tit') },
                        desc: { text: '' },
                        items: bannerData3,
                    }}
                    cssStyle={{
                        type: 'container_image_with_text_top',
                        titleStyle: { margin: '.06rem 0 .3rem 0' },
                        webpUrl,
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />

            <div className="textImg">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        synopsisFontSize: locale === 'jp' ? 0.22 : 0.24,
                        webpUrl,
                    }}
                    data={{
                        title: languageT('textData2_tit'),
                        synopsis: languageT(locale === 'jp' ? 'textData2_synopsis_h5' : 'textData2_synopsis'),
                        desc: languageT('textData2_desc'),
                        img_url: '/img/mobile/solarpanel/material.png',
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <OtherList
                data={getDetaileMoreProducts(
                    gloproductlist,
                    product[locale] || product.us,
                    '',
                    '',
                    `https://${locale}.ecoflow.com/collections/portable-power-stations`,
                )}
            />
        </div>
    );
}
